<!-- go-chat-duplication-->
<a
  [routerLink]="notification().link"
  mat-menu-item
  class="notification-link"
  (click)="notificationClicked()"
  [class.read-notification]="notification().readAtTime !== null">
  <div class="notification-content">
    <div class="notification-header">
      <mat-icon inline>{{ notification().icon }}</mat-icon>
      <div>{{ notification().title }}</div>
    </div>
    <div id="notification-message">
      {{ notification().message }}
    </div>
  </div>
  <div id="timestamp" class="timestamp-end">
    {{ notification().timestamp.toDate().toLocaleDateString('en-GB') }}
    {{ notification().timestamp.toDate() | convertDateToTime: true }}
  </div>
</a>
